module.exports = __webpack_public_path__ + "img/42.4e0bf62.png";